$(document).ready(()=> {

    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });

    $('[data-toggle]').on('click', function()
    {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $('[data-toggle="showbox"][data-target="'+target_name+'"]');

        if(toggle_name == 'openbox')
        {
            let target_status = target_element.data('status');
            $('[data-toggle="showbox"]:not([data-target="'+target_name+'"])').attr('data-status',false);

            if(target_status == false)
            {
                target_element.attr('data-status',true);
            }
            else
            {
                target_element.attr('data-status',false);
            }
        }
        else if(toggle_name == 'closebox')
        {
            target_element.attr('data-status',false);
        }
    });

    $(document).on('click',function(){
        $('[data-toggle="showbox"]').attr('data-status',false);
    });

    $(document).on('keyup',function(e) {
        if (e.key === "Escape") {
            $('[data-toggle="showbox"]').attr('data-status',false);
        }
    });

    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function(event){
        event.stopPropagation();
    });


//========== slider ==============//

    var intro_slider = new Swiper('.intro .swiper-container', {
        slidesPerView: 1,
        loop: 1,
        speed: 300,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0
        },
        pagination: {
            el: '.swiper-pagination',
        },

    });

	var most_visited_slider = new Swiper('.most-visited .swiper-container', {
        slidesPerView:1.2,
        spaceBetween: 30,
        loop: 1,
        speed: 300,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0
        },
        breakpoints: {
          1200: {
              slidesPerView:4,
          },
          992: {
              slidesPerView:3.42,
          },
          768: {
              slidesPerView:2.57,
          },
          480: {
              slidesPerView:1.7,
          },
      },
      pagination: {
        el: '.swiper-pagination',
      },
 
    });

    

    $(document).on('mouseover','.most-visited',function(){
        $.each(most_visited_slider,function(i,e){
            most_visited_slider[i].autoplay.stop();
        })
        
    })

    $(document).on('mouseleave','.most-visited',function(){
		$.each(most_visited_slider,function(i,e){
            most_visited_slider[i].autoplay.start();
        })
	})


    var product_single__related = new Swiper('.product-single__related .swiper-container', {
        slidesPerView:1.2,
        spaceBetween: 30,
        speed: 300,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0
        },
        breakpoints: {
            1200: {
                slidesPerView:4,
            },
            992: {
                slidesPerView:3.42,
            },
            768: {
                slidesPerView:2.57,
            },
            480: {
                slidesPerView:1.7,
            },
        },
        pagination: {
            el: '.swiper-pagination',
        },
 
    });
	
  //============ end slider ==============//

  //============ map ===============//
  if($('#mapid').length > 0)
    {
        var lat = $('#mapid').data("lat")
        var long = $('#mapid').data("long")

        var mymap = L.map('mapid').setView([lat, long], 18);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'your.mapbox.access.token'
        }).addTo(mymap);

        var map_icon = L.icon({
            iconUrl: global_object.home_url+'/wp-content/themes/vistamehr/img/location.png',
            iconSize: [30, 42],
            iconAnchor: [30, 42],
            popupAnchor: [0, -40]
        });
        var marker = L.marker([lat, long], { icon: map_icon, }).addTo(mymap);
    }
    //============ end map =================//

    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    $(document).on('click','.other-product .tab > ul li',function() {

        let $this = $(this);
        let $wrapper = $('#product_view');
        let data = {};
        data['catid'] = $this.data('catid');
        data['nonce'] = $this.data('nonce');
        data['action'] = 'get_product_by_cat';
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function (data)
            {
                $this.addClass('active').siblings().removeClass('active')
                if(data.status == 0)
                {
                    $wrapper.html('<p>'+data.message+'</p>');
                }
                else
                {
                    $wrapper.html(data);
                }
            },
            error: function (data) {
                
            }
        });
    });

    var product_image_thumb = new Swiper('.product-single__gallery .swiper-container.small-slider', {
        slidesPerView: 4,
        spaceBetween: 10,
        centeredSlide: 1,
        on: {
            click: function()
            {
                $(this.clickedSlide).addClass('active').siblings().removeClass('active')
                product_image_thumb.slideTo(this.clickedIndex);
            }
        }
    });

    if($('body').attr('data-lang') == 'en')
    {
        var pos = -760;
    }
    else
    {
        var pos = 80;
    }

    var opt = {
        borderSize: 0,
        zoomWindowOffsetX: pos,
        scrollZoom: 1,
    }

    $("#zoom_image").ezPlus(opt);

    $('.venobox').venobox({
        bgcolor: 'transparent',
        overlayColor: 'rgba(255,255,255,0.9)'
    });

    $('.product-single__gallery__thumb').on('click',function(e){
        e.preventDefault();
        var src = $(this).find('img').attr('src');
        var src_zoom = $(this).find('a').attr('href');
        $('.zoomContainer').remove();
        $('.product-single__gallery__item__image').html('<img id="zoom_image" src="'+ src +'" data-zoom-image="'+ src_zoom +'">');
        $("#zoom_image").ezPlus(opt);

        $('.product-single__gallery__zoom > a').attr('href',src_zoom);

        
        $('.product-single__gallery__thumb > a').addClass('vbox-item venobox');
        $(this).find('a').removeClass('vbox-item venobox')
    });
 
    $("#totop").click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() >= 200) {
            $('#totop').addClass('totop--show');
        } else {
            $('#totop').removeClass('totop--show');
        }
    });

    $( '.comment-like-ajax' ).on( 'click', function( e ) {
        e.preventDefault();
        let ele = $( this );
        let parent = $( this ).parents( '.comments__item' );
        let data = {};
        data['postid'] = parent.data( 'postid' );
        data['commentid'] = parent.data( 'commentid' );
        data['nonce'] = parent.data( 'nonce' );
        data['type'] = ele.data( 'type' );
        data['action'] = 'comment_like';
        $.ajax( {
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function( data ) {
                if (data.status == 1) {
                    ele.toggleClass('active');
                    if (ele.data('type') == 'like' && parent.find( '.like-count' )) {
                        parent.find( '.like-count' ).html( data.info.count );
                    }
                    if (ele.data( 'type' ) == 'dislike' && parent.find( '.dislike-count' )) {
                        parent.find( '.dislike-count' ).html( data.info.count );
                    }
                    Toast.fire( {
                        icon: 'success',
                        title: 'انجام شد',
                        // footer: data.message,
                    } );
                } else {
                    Toast.fire( {
                        icon: 'error',
                        title: 'متاسفانه انجام نشد',
                        // footer: data.message,
                    } );
                }
            },
            error: function() {
                Toast.fire( {
                    icon: 'error',
                    title: 'متاسفانه انجام نشد',
                    // footer: 'در ارسال درخواست مشکلی وجود دارد.',
                } );
            },
        } );
    } );

    $('.single-blog__like a').on('click', function (e) {
        e.preventDefault();
        let ele = $(this);
        let data = {};
        data['postid'] = ele.data('postid');
        data['nonce'] = ele.data('nonce');
        data['type'] = ele.data('type');
        data['action'] = 'post_like';
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_object.ajax_url,
            data: data,
            success: function (data) {
                console.log(data)
                if (data.status == 1) {
                    Toast.fire({
                        icon: 'success',
                        title: 'انجام شد',
                        // footer: data.message,
                    });

                    ele.toggleClass('active');
                    if (ele.find('span')) {
                        ele.find('span').html(data.info.count);
                    }
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'متاسفانه انجام نشد',
                        // footer: data.message,
                    });
                }
            },
            error: function () {
                Toast.fire({
                    icon: 'error',
                    title: 'متاسفانه انجام نشد',
                    // footer: 'در ارسال درخواست مشکلی وجود دارد.',
                });
            }
        });
    });



    $('.products-list__filter__item__checkbox ul input').on('change', function(){
        if ($(this).is(':checked'))
        {
            if ($(this).val() == 'all')
            {
                $(this).parent().siblings('li').find('input').prop('checked', false);
            }
            else
            {
                $('.products-list__filter__item__checkbox ul input[value=all]').prop('checked', false);
            }
        }

        $category_check = '';
        $('.products-list__filter__item__checkbox ul input').each(function(i,e){
            if ($(this).is(':checked'))
            {
                $category_check += $(this).val() + '-';
            }
            $('#category_check').val($category_check.slice(0,-1))
        })



    })

});


